/*
 * Usage:
 * .js-check-container -> group the checkboxes
 *  .js-check-all -> toggling this one, also checks/unchecks all `.js-check-one` checkboxes in the container
 *  .js-check-one -> toggles this one and also checks js-check-all if all js-check-one are checked in the js-check-container
 *  .js-check-one
 * ...
 */

$(document).ready(function () {
  $('.js-check-container .js-check-all').on('change', function(e){
    var container = $(e.target).closest('.js-check-container')
    $('input:checkbox', container).prop('checked', this.checked);
  });

  $('.js-check-container .js-check-one').on('change', function(e){
    var container = $(e.target).closest('.js-check-container')
    var check_all = $(e.target).closest('.js-check-container')
      .find('.js-check-all')
    if ($('.js-check-one:checked', container).length == $('.js-check-one', container).length) {
      $(check_all).prop('checked', true);
    } else {
      $(check_all).prop('checked', false);
    }
  });
});
